const PropTypes = require('prop-types');
// @vendors
const React = require('react');
// @utilities
const { FormattedText } = require('core/i18n').i18n;
// @Components
const { OKButton } = require('components/commons/OKButton/OKButton');
const ChatStatusContainer = require('components/chat/status/ChatStatusContainer');
// @constants
const {
    CHAT_CONVERSATION_STATUS: {
        ACTIVE,
        CONNECTING,
        DISCONNECTED,
        ERROR,
        INACTIVE
    }
} = require('constants/chat');

require('./ChatBar.scss');

class ChatBar extends React.Component {

    buildCloseQuestion(){
        const {
            closeWindowCancel,
            endConversation,
            showCloseQuestion
        } = this.props;
        let closeQuestion;

        if (showCloseQuestion) {
            closeQuestion = (
                <div className="chat-bar__close-question">
                    <FormattedText
                        value="chat-closeQuestion"
                        className="chat-bar__close-question-text"
                    />
                    <div className="chat-bar__close-question-buttons">
                        <span className="chat-bar__close-question-button">
                            <OKButton modifier="ghost" inverse={true} onClick={closeWindowCancel} size="small">
                                <FormattedText value="chat-closeStayBtn" />
                            </OKButton>
                        </span>
                        <span className="chat-bar__close-question-button chat-bar__close-question-button--with-left-margin">
                            <OKButton modifier="primary" onClick={endConversation} size="small">
                                <FormattedText value="chat-closeLeaveBtn" />
                            </OKButton>
                        </span>
                    </div>
                </div>
            );
        }

        return closeQuestion;
    }

    buildDisconnectedNotice(){
        const { startConversation, conversationStatus, timer, msgReceiveFail, disconnectNotice } = this.props;
        let disconnectedNotice;
        if(msgReceiveFail && timer) {
            disconnectedNotice = (
                <div className="chat-bar__disconnected-notice">
                    <i className="icon-error chat-bar__reconnecting-notice-icon" />
                    <FormattedText value="chat-reconnectingText" />
                </div>
            );
        } else if (conversationStatus === DISCONNECTED || (msgReceiveFail && !timer)) {
            disconnectNotice();
            disconnectedNotice = (
                <div className="chat-bar__disconnected-notice">
                    <i className="icon-error chat-bar__disconnected-notice-icon" />
                    <FormattedText value="chat-disconnectedText" />
                    <OKButton
                        modifier="link-complementary"
                        onClick={startConversation}
                    >
                        <FormattedText value="chat-disconnectedLink" />
                    </OKButton>
                </div>
            );
        }
        return disconnectedNotice;
    }

    render() {
        const {
            chatAvailabilityStatusData,
            closeWindowAsk,
            closeWindowConfirm,
            conversationStatus,
            toggleWindow
        } = this.props;
        const nextOpening = chatAvailabilityStatusData.get('nextOpening');
        let closeButtonBehavior;
        if(nextOpening > 0) {
            closeButtonBehavior = closeWindowConfirm;
        } else {
            closeButtonBehavior = [ERROR, DISCONNECTED, INACTIVE].includes(conversationStatus) ? closeWindowConfirm : closeWindowAsk;
        }
        const closeQuestion = this.buildCloseQuestion();
        const disconnectedNotice = this.buildDisconnectedNotice();
        return (
            <div className="chat-bar">
                <div className="chat-bar__status">
                    <ChatStatusContainer />
                </div>
                <FormattedText value="chat-title" />
                <div className="chat-bar__button-wrapper-menu">
                    <OKButton modifier="secondary" size="small" onClick={closeButtonBehavior}>
                        <i className="chat-bar__button-icon icon-cerrar" />
                    </OKButton>
                </div>
                <div className="chat-bar__button-wrapper-menu chat-bar__button-wrapper-menu--minimize">
                    <OKButton modifier="secondary" size="small" onClick={toggleWindow}>
                        <i className="chat-bar__button-icon icon-minimizar" />
                    </OKButton>
                </div>
                {disconnectedNotice}
                {closeQuestion}
            </div>
        );
    }
}

ChatBar.propTypes = {
    chatAvailabilityStatusData: PropTypes.object.isRequired,
    closeWindowAsk: PropTypes.func.isRequired,
    closeWindowCancel: PropTypes.func.isRequired,
    closeWindowConfirm: PropTypes.func.isRequired,
    conversationStatus: PropTypes.oneOf([
        ACTIVE,
        CONNECTING,
        DISCONNECTED,
        ERROR,
        INACTIVE
    ]).isRequired,
    disconnectNotice:PropTypes.func.isRequired,
    endConversation: PropTypes.func.isRequired,
    msgReceiveFail: PropTypes.bool,
    retrieveMessages: PropTypes.func.isRequired,
    showCloseQuestion: PropTypes.bool.isRequired,
    startConversation: PropTypes.func.isRequired,
    toggleWindow: PropTypes.func.isRequired,
    timer: PropTypes.bool.isRequired
};

module.exports = ChatBar;
